import {Dialog, LinearProgress, Typography} from "@material-ui/core";
import React from "react";
import {useGlobalStyles} from "../../utils/styles";

export default function UpdatingDialog(props) {
    const {open, progress, variant} = props;
    const globalClasses = useGlobalStyles();

    const isIndeterminate = variant === 'indeterminate' || progress === undefined;
    const progressValue = isIndeterminate ? undefined : Math.min(100, Math.max(0, progress));

    return (
        <Dialog open={open} disableBackdropClick disableEscapeKeyDown>
            <LinearProgress
                classes={{
                    colorPrimary: globalClasses.progressBar,
                    barColorPrimary: globalClasses.progressBarBackground
                }}
                style={{
                    width: "100%",
                    maxWidth: "100vw",
                    height: isIndeterminate ? '0.2em' : '4px',
                    visibility: open ? undefined : 'hidden'
                }}
                variant={isIndeterminate ? 'indeterminate' : 'determinate'}
                value={progressValue}/>
            <div style={{
                display: "flex", 
                flexDirection: "column", 
                gap: "8px", 
                padding: "24px",
                minWidth: isIndeterminate ? "auto" : "400px"
            }}>
                <Typography variant="h6">
                    {props.title ? props.title : "Updating..."}
                </Typography>
                <Typography variant="body2" style={{color: "rgba(0, 0, 0, 0.6)"}}>
                    {props.subtitle ? props.subtitle : "Please wait while we update the product."}
                </Typography>
                {!isIndeterminate && (
                    <Typography variant="caption" style={{marginTop: "4px", color: "rgba(0, 0, 0, 0.5)"}}>
                        {Math.round(progressValue)}% complete
                    </Typography>
                )}
            </div>
        </Dialog>
    )
}
